module.exports = __webpack_public_path__ + "static/media/garuda2.bd55ccc4.jpg";